module.exports = __webpack_public_path__ + "static/img/Adult-Human-Torso-A01-X-Ray6.5cb8b03a.jpg";